import { createSlice } from "@reduxjs/toolkit";

interface NavbarState {
  isOpen: boolean;
}

const initialState: NavbarState = {
  isOpen: false,
};

const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    toggle: (state) => {
      state.isOpen = !state.isOpen;
    },
    setOpen: (state, action) => {
      state.isOpen = action.payload;
    },
  },
});

export const { toggle, setOpen } = navbarSlice.actions;
export default navbarSlice.reducer;
